import React, { Component } from "react";
import "./EditWarehouse.scss";
import { Link } from "react-router-dom";
import arrowBack from "../../assets/Icons/arrow_back-24px.svg";
import axios from "axios";

class EditWarehouse extends Component {
  state = {
    WarehouseName: "",
    StreetAddress: "",
    City: "",
    Country: "",
    ContactName: "",
    Position: "",
    PhoneNumber: "",
    Email: "",
  };

  componentDidMount() {
    // change titiel of webpage
    document.title = "Edit Warehouse";
    //using id passsed in url get info about that warehouse
    this.fetchWarehouseInfo();
  }

  fetchWarehouseInfo() {
    // get warehouse id from url
    let id = this.props.match.params.id;
    axios
      .get(`https://instock-api-rbht.onrender.com/api/v1/warehouses/${id}`)
      .then((response) => {
        console.log(response.data);
        let data = response.data;
        this.setState({
          WarehouseName: data.name,
          StreetAddress: data.address,
          City: data.city,
          Country: data.country,
          ContactName: data.contact.name,
          Position: data.contact.position,
          PhoneNumber: data.contact.phone,
          Email: data.contact.email,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const warehouse = {
      name: this.state.WarehouseName,
      address: this.state.StreetAddress,
      city: this.state.City,
      country: this.state.Country,
    };
    const contact = {
      name: this.state.ContactName,
      position: this.state.Position,
      phone: this.state.PhoneNumber,
      email: this.state.Email,
    };

    // calls isFormValid to make sure all inputs are valid before editing
    // if valid updated data is sent to backend
    if (this.isFormValid()) {
      // get warehouse id from url
      //let id =  this.props.match.params.id
      // hardcoded url for testing
      let id = "58828104-30ab-49dc-95b5-99b0fce76e54";
      axios
        .put(`http://localhost:8080/api/v1/warehouses/${id}`, {
          warehouse,
          contact,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // redirect them back
    this.props.history.goBack();
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // uses values from isWareHouseValid & isContactValid to see if form as a whole is valid
  isFormValid = () => {
    if (!this.isWareHouseValid() && !this.isContactValid()) {
      return false;
    }

    return true;
  };

  // function to check if contact info is valid
  isContactValid = () => {
    if (
      !this.state.ContactName.trim() ||
      !this.state.Position.trim() ||
      !this.state.PhoneNumber.trim() ||
      !this.state.Email.trim()
    ) {
      return false;
    }
    return true;
  };

  // function to check if warehouse info is valid
  isWareHouseValid = () => {
    if (
      !this.state.WarehouseName.trim() ||
      !this.state.StreetAddress.trim() ||
      !this.state.City.trim() ||
      !this.state.Country.trim()
    ) {
      return false;
    }
    return true;
  };

  // returns user to home if cancel button is clicked
  handleCancel = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        <section className="editWarehouse">
          <div className="editWarehouse-section-wrapper">
            {/* Header */}
            <div className="editWarehouse__title-wrapper">
              <Link to={"/warehouse"}>
                <img
                  className="editWarehouse__title--icon"
                  alt="go back arrow"
                  src={arrowBack}
                />
              </Link>
              <h1 className="editWarehouse__title">Edit Warehouse</h1>
            </div>
            <div className="editWarehouse-wrapper">
              {/* Warehouse details section*/}
              <form
                className="editWarehouse__form"
                onSubmit={this.handleSubmit}
              >
                {/* Tablet wrapper wraps both warehouse and contact details div for tablet view */}
                <div className="editWarehouse-tablet-wrapper">
                  <div className="editWarehouse__details">
                    <h2 className="editWarehouse__details--header">
                      Warehouse Details
                    </h2>
                    {/* Warehouse details form*/}
                    {/*Warehouse Name */}
                    <label className="editWarehouse__form--label">
                      Warehouse Name
                    </label>
                    <input
                      className={
                        this.state.WarehouseName.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.WarehouseName}
                      name="WarehouseName"
                      placeholder="Warehouse Name"
                    ></input>
                    {/* Street adress */}
                    <label className="editWarehouse__form--label">
                      Street Address
                    </label>
                    <input
                      className={
                        this.state.StreetAddress.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.StreetAddress}
                      name="StreetAddress"
                      placeholder="Street Address"
                    ></input>
                    {/* City */}
                    <label className="editWarehouse__form--label">City</label>
                    <input
                      className={
                        this.state.City.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.City}
                      name="City"
                      placeholder="City"
                    ></input>
                    {/* Country */}
                    <label className="editWarehouse__form--label">
                      Country
                    </label>
                    <input
                      className={
                        this.state.Country.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Country}
                      name="Country"
                      placeholder="Country"
                    ></input>
                  </div>
                  {/* Contact details section*/}
                  <div className="editWarehouse__contact">
                    <h2 className="editWarehouse__contact--header">
                      Contact Details
                    </h2>
                    {/* Contact details form*/}
                    {/*Contact Name */}
                    <label className="editWarehouse__form--label">
                      Contact Name
                    </label>
                    <input
                      className={
                        this.state.ContactName.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.ContactName}
                      placeholder="Contact Name"
                      name="ContactName"
                    ></input>
                    {/*Position*/}
                    <label className="editWarehouse__form--label">
                      Position
                    </label>
                    <input
                      className={
                        this.state.Position.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Position}
                      placeholder="Position"
                      name="Position"
                    ></input>
                    {/*Phone Number */}
                    <label className="editWarehouse__form--label">
                      Phone Number
                    </label>
                    <input
                      className={
                        this.state.PhoneNumber.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.PhoneNumber}
                      name="PhoneNumber"
                      placeholder="Phone Number"
                    ></input>
                    {/*Email */}
                    <label className="editWarehouse__form--label">Email</label>
                    <input
                      className={
                        this.state.Email.length > 0
                          ? "editWarehouse__form--input"
                          : "editWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Email}
                      name="Email"
                      placeholder="Email"
                    ></input>
                  </div>
                </div>
                {/*Button Container */}
                <div className="editWarehouse__button-container">
                  <div className="editWarehouse__button-wrapper">
                    <button
                      onClick={this.handleCancel}
                      className="editWarehouse__button--cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className="editWarehouse__button--save"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default EditWarehouse;
